/**
 * External dependencies
 */
import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql, withPrefix } from 'gatsby';
import { initBrazeWebSDK } from '../utilities/';

/**
 * Internal dependencies
 */
import { Layout } from '../components';

function Page({ children, data, className = '', title = '' }) {
  initBrazeWebSDK();
  const bootstrapPath = withPrefix(`/css/bootstrap.css`);
  const stylesheetPath = withPrefix(`/css/all.css`);
  const miTrackingScript = withPrefix(`/js/mi.js`);
  const tealiumTrackingScript = withPrefix(`/js/tealium.js`);
  const segmentTrackingScript = withPrefix(`/js/segment.js`);
  const mParticleTrackingScript = withPrefix(`/js/mParticle.js`);
  const heapScript = withPrefix(`/js/heap.js`);
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: 'description', content: `Inkredible Retail - ${title}` },
            ]}
          >
            <meta name="trustpilot-one-time-domain-verification-id" content="7acfc846-6e1f-4370-b3fd-3257d2051867"/>
            <html lang="en" />
            <link rel="stylesheet" type="text/css" href={bootstrapPath} />
            <link rel="stylesheet" type="text/css" href={stylesheetPath} />
            <script type="text/javascript" src={miTrackingScript} />
            <script type="text/javascript" src={tealiumTrackingScript} />
            <script type="text/javascript" src={segmentTrackingScript} />
            <script type="text/javascript" src={mParticleTrackingScript} />
            <script type="text/javascript" src={heapScript} />
          </Helmet>
          <Layout>{children}</Layout>
        </>
      )}
    />
  );
}

export default Page;
